export const meta = {
  id: "FW-01",
  name: "Vantic",
  slug: "vantic",
  title: "Vantic — a Fable World: SaaS launch page",
  description:
    "An original SaaS launch landing page designed by Fable: asymmetric editorial layout, scroll-scrubbed operations thread, cobalt on bone."
} as const;

export default meta;
